// extracted by mini-css-extract-plugin
export default {"container":"MarketPage_container__8jIF8","sideBar":"MarketPage_sideBar__owY+8"};